import React from "react";
import Button from "@/ui/Button/Button";
import Modal from "@/ui/Modal/Modal";
import Typography from "@/ui/Typography/Typography";
import cls from "./styles.module.scss";

interface RegionConfirmModalProps {
  cityName: string;
  isOpen: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const RegionConfirmModal = ({
  cityName,
  isOpen,
  isLoading,
  onConfirm,
  onCancel,
}: RegionConfirmModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={isLoading ? () => undefined : onCancel}
    hideHeader
    contentClassName={cls.modalContent}
  >
    <div className={cls.root}>
      <div className={cls.copy}>
        <Typography component="h2" size="2xl" weight="bold" family="custom">
          {`Ты в ${cityName}?`}
        </Typography>
        <Typography
          component="p"
          size="md"
          weight="medium"
          family="Onest"
          color="var(--text-dark-secondary)"
        >
          Убедись что выбрал правильно
          <br />
          — изменить город нельзя.
        </Typography>
      </div>
      <div className={cls.actions}>
        <Button
          label="Да, я здесь"
          variant="primary"
          loading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
        />
        <Button
          label="Выбрать другой"
          variant="graphite"
          disabled={isLoading}
          onClick={onCancel}
        />
      </div>
    </div>
  </Modal>
);
